module.exports = __webpack_public_path__ + "static/media/1.13eac85f.JPG";